// extracted by mini-css-extract-plugin
export default {"card":"LoadingCard_card__+JB5-","text":"LoadingCard_text__G6hoJ","spinner":"LoadingCard_spinner__1-Rku","spin":"LoadingCard_spin__pAwMN"};